<script setup>
import {defineProps, computed} from 'vue'
import {useFilterStore} from '@/store/filter'

const props = defineProps({
  count: {type: Number, default: 0},
  openKey: {type: String, default: null}   // ← new
})

const filterStore = useFilterStore()
const isDisabled = computed(() => filterStore.loadingApply)

/**
 * Reset-all handler.
 * - No-ops if the action is missing.
 * - Calls store.clearSelected() to purge all active filters.
 * - After reset, re-fetches options for the currently open panel (props.openKey),
 *   so that its options reflect the unfiltered state.
 */
async function resetAll() {
  if (!filterStore?.clearSelected) return
  await filterStore.clearSelected({refetchKey: props.openKey || null})
}
</script>

<template>
  <div class="reset-wrapper">
    <button
      v-if="count > 0"
      class="btn -btn-black"
      type="button"
      :disabled="isDisabled"
      :aria-busy="isDisabled ? 'true' : 'false'"
      @click="resetAll">
      <span class="icon-return-before"></span>
      {{ $t('filterLabels.resetAll') || 'Alle Filter zurücksetzen' }}
    </button>
  </div>
</template>
